import { StandardTabs } from '@dreryk/react-components';

import { VisitHistoryWithConfidentialDetails } from '~libs.shared.visit';

import { visitHistoryTranslationKeys } from '../translations';
import VisitSettlement from '../visitSettlement';

import { VisitHistoryDiagnosisTable } from './VisitHistoryDiagnosisTable';
import { VisitHistoryProceduresTable } from './VisitHistoryProceduresTable';

type VisitHistoryInterviewTabsProps = {
   readonly visitHistory: VisitHistoryWithConfidentialDetails;
};

export const VisitHistoryInterviewTabs = (props: VisitHistoryInterviewTabsProps): JSX.Element => {
   const { confidentialDetails } = props.visitHistory;
   return (
      <StandardTabs testId={'icd'}>
         <StandardTabs.Tab
            id={'diagnosis'}
            testId={'diagnosis'}
            label={visitHistoryTranslationKeys.interviewTabs.diagnosis}
            count={confidentialDetails.diagnosisCount}
         >
            <VisitHistoryDiagnosisTable diagnoses={confidentialDetails.diagnoses} />
         </StandardTabs.Tab>

         <StandardTabs.Tab
            id={'procedures'}
            testId={'procedures'}
            label={visitHistoryTranslationKeys.interviewTabs.procedures}
            count={confidentialDetails.procedureCount}
         >
            <VisitHistoryProceduresTable visitId={props.visitHistory.id} />
         </StandardTabs.Tab>

         {VisitSettlement.useMedicalServicesTab({ appointmentId: props.visitHistory.appointmentId })}
      </StandardTabs>
   );
};
